import { render } from "./SurchargeProductDetails.vue?vue&type=template&id=07acaa33&scoped=true&ts=true"
import script from "./SurchargeProductDetails.vue?vue&type=script&lang=ts"
export * from "./SurchargeProductDetails.vue?vue&type=script&lang=ts"

import "./SurchargeProductDetails.vue?vue&type=style&index=0&id=07acaa33&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07acaa33"]])

export default __exports__